// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"140":"e0057f7e","759":"23eb9ea6","803":"dbfe55a5","820":"fd55170b"}[chunkId] + ".css";
};